<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="equipmentStatusMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="equipmentStatusCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.equipStatus') }}</v-card-title
            >
            <v-data-table
              id="equipmentStatusTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">
                    {{ props.item.equipmentStatusID }}
                  </td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: left">
                    {{ props.item.projectName }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselName }}
                  </td>
                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon> </v-btn
                    >&nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted === true"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.equipmentStatusID"
                          :rules="[
                            () =>
                              !!editedItem.equipmentStatusID || requiredMessage
                          ]"
                          required
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.equipStatusId') }}
                          </template></v-text-field
                        >
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.projectId || requiredMessage
                          ]"
                          required
                          :items="projects"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.projectId"
                          :readonly="editedIndex != -1"
                          @change="onDlgProjectChange"
                          ><template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.projectName') }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.vesselId || requiredMessage
                          ]"
                          required
                          class="form-control"
                          :items="projectVessels"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.vesselId"
                          :readonly="editedIndex != -1"
                          @change="onDlgVesselChange"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.asset') }}
                          </template>
                        </v-select></v-col
                      >

                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.description"
                          :rules="[
                            () => !!editedItem.description || requiredMessage
                          ]"
                          required
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('column.description') }}
                          </template></v-text-field
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddequipmentStatus"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import ProjectAsset from '../common/ProjectAsset'

export default {
  components: {
    'project-asset': ProjectAsset
  },
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.equipStatusId'),
          align: 'left',
          sortable: true,
          value: 'equipmentStatusID',
          width: '15%'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('common.projectName'),
          align: 'left',
          value: 'projectId'
        },
        {
          text: this.$t('common.asset'),
          align: 'left',
          value: 'vesselId'
        },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'opactions',
          sortable: false,
          width: '20%'
        }
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null
    }
  },
  computed: {
    ...mapGetters([
      'getEquipmentStatus',
      'm_equip/getNextSeqCode',
      'm_equip/getEquipmentStatuses',

      'm_project/getProjectNames',
      'm_project/getProjectVesselIds',

      'm_vessel/getVesselNames',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',
      'm_passet/getSelProjectVesselIds'
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.equipStatus')
        : this.$t('common.edit') + ' ' + this.$t('nav.equipStatus')
    },
    items() {
      return this['m_equip/getEquipmentStatuses']
    },
    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    projectVessels() {
      let vessels = this.vessels

      let pvIds = this['m_passet/getSelProjectVesselIds']
      if (this.dlgSelProjectId) {
        pvIds = this['m_project/getProjectVesselIds']
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1)
    },
    formIsValid() {
      return (
        this.editedItem.equipmentStatusID &&
        this.editedItem.description &&
        this.editedItem.projectId &&
        this.editedItem.vesselId
      )
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']

    this.refreshEquipmentStatuses()
    this.refreshNextSeqCode()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },
  methods: {
    ...mapActions([
      'm_equip/fetchEquipmentStatuses',
      'm_equip/fetchNextSeqCode',
      'm_equip/deleteEquipmentStatus',
      'm_equip/updateEquipmentStatus',
      'm_equip/createEquipmentStatus',

      'm_project/fetchProjectVesselNames'
    ]),
    ...mapMutations(['mHideLongLoader']),

    refreshEquipmentStatuses() {
      this['m_equip/fetchEquipmentStatuses']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshEquipmentStatuses()
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshEquipmentStatuses()
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId
      this.$log.debug('dlg project change', this.dlgSelProjectId)
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)
      this.refreshNextSeqCode()
    },

    onDlgVesselChange() {
      this.$log.debug('dlg vessel changed', this.editedItem.vesselId)
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return
      }

      this.refreshNextSeqCode()
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId

      this['m_equip/fetchNextSeqCode']({
        pId: pId,
        vId: vId
      }).then((nextCode) => {
        this.editedItem.equipmentStatusID = nextCode
        this.$nextTick(() => this.$forceUpdate())
      })
    },

    resetEntity(item) {
      this.dlgSelProjectId = null
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)

      this.defaultItem.projectId = this['m_passet/getSelProjectId']
      this.defaultItem.vesselId = this['m_passet/getSelVesselId']

      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.onDlgProjectChange()
      this.dialog = true
    },

    createItem() {
      this.resetEntity()

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange()
      }

      this.refreshNextSeqCode()
      this.editedItem.equipmentStatusID = this.getMaxCode
      this.dialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'

      this.$confirm(this.$t(msg) + this.$t('nav.equipStatus') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then(
        (res) =>
          res &&
          this['m_equip/deleteEquipmentStatus'](this.editedItem).then(
            this.refreshEquipmentStatuses
          )
      )
    },
    close() {
      this.$refs.form.resetValidation()
      this.dialog = false
    },
    save() {
      if (~this.editedIndex) {
        this['m_equip/updateEquipmentStatus'](this.editedItem).then(this.refreshEquipmentStatuses)
      }

      if (!~this.editedIndex) {
        this['m_equip/createEquipmentStatus'](this.editedItem).then(this.refreshEquipmentStatuses)
      }  

      this.close()
    }
  }
}
</script>

<style>
#equipmentStatussTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#equipmentStatussTable header {
  font-weight: bold;
}
#equipmentStatussCard {
  width: auto;
}
</style>